import React from "react";

export default function About({ id }) {
  return (
    <div id={id} className="section py-constant">
      <div className="container">
        <div className="subtitle">About</div>

        <h2 className="h2    title center">
          Created by Shopify Merchants
          <br />
          <span className="accent"> For Shopify Merchants</span>
        </h2>

        <div className="text-md text-width">
          We built CustomerGenius after personally experiencing repeated
          discount abuse, costly chargebacks, and wasted customer service hours.
          This app solved our problem—and now it can solve yours
        </div>
      </div>
    </div>
  );
}
